import { removeCardFromColumn } from '@domain/_redux/workflow/actions/actions';
import { createMiddleware } from '@shared/redux';
import { showErrorToast, showSuccessToast } from '@shared/toasts/toasts.state';
import { getCardById } from '../../workflow/workflow.state';
import { closeCardModal } from '../interface';
import { DISMISS_TEXT } from './dismiss.constants';
import {
    dismissCardRequest,
    DISMISS_CARD,
    DISMISS_CARD_REQUEST_FAILED,
    DISMISS_CARD_REQUEST_SUCCEEDED,
} from './dismiss.state';
import { getCardOriginRouter, getCardSelected, setCardSelected } from '../card-selected/card-selected.state';
import { isCardFromExternalLink } from '../card-selected/card-selected.utils';
import {
    isModalOpen as getIsModalOpen,
} from '../interface/card-interface.state';

export const cardDismissMiddlewares = createMiddleware({
    [DISMISS_CARD]: (state, action) => [
        dismissCardRequest({
            cardId: action.payload.cardId,
            days: action.payload.days,
        }),
    ],
    [DISMISS_CARD_REQUEST_SUCCEEDED]: (state, action) => {
        const cardId = action.payload.data.id;
        const card = getCardById(state, cardId);
        const originRoute = getCardOriginRouter(state);
        const isFromExternalLink = isCardFromExternalLink(originRoute);
        const isModalOpen = getIsModalOpen(state);
        const cardSelected = getCardSelected(state);

        const closeCardModalAction = isModalOpen
            ? [
                setCardSelected({
                    card: cardSelected,
                    originRoute,
                    cardFieldsModified: false,
                }),
                closeCardModal(),
            ]
            : [];

        const removeFromColumnAction = isFromExternalLink && isModalOpen
            ? []
            : [removeCardFromColumn(card)];

        return [
            ...removeFromColumnAction,
            showSuccessToast({ message: DISMISS_TEXT.TOAST.SUCCESS }),
            ...closeCardModalAction,
        ];
    },
    [DISMISS_CARD_REQUEST_FAILED]: () => showErrorToast({ message: DISMISS_TEXT.TOAST.ERROR }),
});
